import { render, staticRenderFns } from "./UnsentCurriculumListItem.vue?vue&type=template&id=6795138a&scoped=true&lang=pug"
import script from "./UnsentCurriculumListItem.vue?vue&type=script&lang=js"
export * from "./UnsentCurriculumListItem.vue?vue&type=script&lang=js"
import style0 from "./UnsentCurriculumListItem.vue?vue&type=style&index=0&id=6795138a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6795138a",
  null
  
)

export default component.exports